import classNames from 'classnames';
import CardWrapper from 'components/CardWrapper';
import { OrgServiceModelType } from 'models/OrgServiceModel';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import EditMenu from 'components/EditMenu';
import MenuButton from 'components/MenuButton';
import { inject } from 'mobx-react';
import { OrganizationsStoreType } from 'models/OrganizationsStore';
import { DataStoreType } from 'models/DataStore';
import OrgServiceItemEditPopup from './OrgServiceItemEditPopup';
import Icon from 'components/Icon';

interface OrgServiceItemProps {
  service: OrgServiceModelType;
  organizationsStore?: OrganizationsStoreType;
  dataStore?: DataStoreType;
}

function OrgServiceItem({
  service,
  organizationsStore,
  dataStore
}: OrgServiceItemProps) {
  const intl = useIntl();

  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <>
      <CardWrapper
        onClick={() => {
          !isDeleting && setIsEditing(true);
        }}
      >
        <h5
          className={classNames({
            'l-row-wrapper': true,
            'l-row-wrapper--spaceBetween': true,
            'l-screen-item__headline--placeholder': !service.name
          })}
        >
          {service.name || intl.formatMessage({ id: 'Service Add Name' })}
          <Icon name="pen" size="large" />
        </h5>
        <span
          className={classNames({
            'l-screen-item__description': true,
            'l-screen-item__description--placeholder': !service.content,
            'l-screen-item__description--evenly': true
          })}
        >
          {service.content || intl.formatMessage({ id: 'Service Add Content' })}
        </span>
        <div
          className="l-row-wrapper l-row-wrapper--spaceBetween"
          style={{
            position: 'absolute',
            bottom: '1rem',
            left: '0',
            right: '1.5em'
          }}
        >
          <div />
          <EditMenu
            label={intl.formatMessage({ id: 'Edit' })}
            onShow={() => setIsDeleting(true)}
            onHide={() => setIsDeleting(false)}
          >
            <MenuButton
              label={intl.formatMessage({ id: 'Remove' })}
              iconName="bin"
              onClick={async () => {
                if (
                  window.confirm(intl.formatMessage({ id: 'Delete Service' }))
                ) {
                  await organizationsStore!.deleteService(
                    dataStore!.currentOrganization!.id,
                    service.id
                  );
                }
              }}
            />
          </EditMenu>
        </div>
      </CardWrapper>
      {isEditing && (
        <OrgServiceItemEditPopup
          onEditDone={() => setIsEditing(false)}
          service={service}
        />
      )}
    </>
  );
}

export default inject('organizationsStore', 'dataStore')(OrgServiceItem);
